module.exports = __webpack_public_path__ + "media/bootstrap-icons/unlock-fill-58769008.svg";